export default __webpack_public_path__ + "static/media/baby-feet.1583aa4b.jpg";